<template>
  <el-dialog
    :visible="showDialog"
    :title="`下载纳税申报表`"
    width="40%"
    class="tax-return"
    @close="close"
  >
    <div class="block">
      <div class="l-common-title">委托代征报表</div>
      <el-form
        :inline="true"
        ref="form1"
        :model="formInline1"
        class="form-inline"
        :rules="rules1"
      >
        <el-form-item label="支付月份：" prop="payMonth">
          <el-date-picker
            v-model="formInline1.payMonth"
            type="month"
            placeholder="请选择月份"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="keysArr.includes('gyEnterpriseId')"
          label="客户企业："
          style="margin-right:35px;margin-left: 10px;"
          prop="gyEnterpriseId"
        >
          <dic-select
            style="width:220px;"
            @dic-select-obj="
              val => {
                formInline1.gyEnterpriseId = val.id;
              }
            "
            :fuzzyDef="searchAjax"
            :prop="{
              label: 'enterprise_name',
              code: 'id'
            }"
            :isDisabled="!formInline1.payMonth"
            :ajaxQueryObj="{
              taskDt: fmtPayMonth
            }"
            ajaxQuery="enterpriseName"
            placeholder="请选择客户企业"
          ></dic-select>
        </el-form-item>
        <el-form-item class="btn-block">
          <el-button
            type="primary"
            @click="submit(exportUrl2, 'form1', 'formInline1')"
            :disabled="!formInline1.payMonth"
          >
            导出
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="block">
      <div class="l-common-title">税收完税报表</div>
      <el-form
        :inline="true"
        ref="form2"
        :model="formInline2"
        class="form-inline"
        :rules="rules2"
      >
        <el-form-item label="支付月份：" prop="payMonth">
          <el-date-picker
            v-model="formInline2.payMonth"
            type="month"
            placeholder="请选择月份"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="keysArr.includes('gyEnterpriseId')"
          label="客户企业："
          style="margin-right:35px;"
          prop="gyEnterpriseId"
        >
          <dic-select
            style="width:220px;"
            @dic-select-obj="
              val => {
                formInline2.gyEnterpriseId = val.id;
              }
            "
            :fuzzyDef="searchAjax"
            :prop="{
              label: 'enterprise_name',
              code: 'id'
            }"
            :isDisabled="!formInline2.payMonth"
            :ajaxQueryObj="{
              taskDt: fmtPayMonth1
            }"
            ajaxQuery="enterpriseName"
            placeholder="请选择客户企业"
          ></dic-select>
        </el-form-item>
        <el-form-item class="btn-block">
          <el-button
            @click="submit(exportUrl1, 'form2', 'formInline2')"
            type="primary"
            :disabled="
              keysArr.includes('gyEnterpriseId')
                ? !formInline2.gyEnterpriseId || !formInline2.payMonth
                : !formInline2.payMonth
            "
          >
            导出
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-group">
      <!-- <el-button @click="submit(exportUrl1, 'form', 'formInline')" type="primary">下载税收完税报告表</el-button>
      <el-button @click="submit(exportUrl2, 'form', 'formInline')" type="primary">下载委托代征报告明细表</el-button>-->
      <el-button @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import dateFormat from '@/tools/dateFormat';
import dicSelect from '@/components/Common/dicSelect.vue';
import { taxDeclaration } from '@/api/ajax';
const d = new Date();
export default {
  name: 'taxReturn',
  components: { dicSelect },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      // 1 三级灵工（工业-薪未来-C）
      // 2 二级灵工
      type: [Number, String],
      default: 1
    }
  },
  data() {
    const validatorMonth = (rule, value, callback) => {
      const d = new Date();
      const nowMonth = dateFormat(d.getTime(), 'YYYY-MM');
      const chooseMonth = value && dateFormat(value.getTime(), 'YYYY-MM');
      if (!value) {
        callback(new Error('请选择月份'));
      } else if (value > d || chooseMonth == nowMonth) {
        callback(new Error('支付月份需小于' + nowMonth));
      } else {
        callback();
      }
    };
    return {
      enterpriseIdIndex: 1,
      keysArr: ['gyEnterpriseId', 'payMonth'],
      formInline1: {
        payMonth: ''
      },
      formInline2: {
        gyEnterpriseId: '',
        payMonth: ''
      },
      rules1: {
        payMonth: [
          {
            required: true,
            trigger: 'change',
            validator: validatorMonth
          }
        ]
      },
      rules2: {
        gyEnterpriseId: [
          { required: true, message: '请选择客户企业', trigger: 'change' }
        ],
        payMonth: [
          {
            required: true,
            trigger: 'change',
            validator: validatorMonth
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          if (
            time.getFullYear() == d.getFullYear() &&
            time.getMonth() == d.getMonth()
          ) {
            return true;
          }
          return time > d;
        }
      },
      searchAjax: taxDeclaration.firstEnterpriseList,
      exportUrl1: taxDeclaration.taxPaymentReportThreeLevels, //下载税收完税报告表接口
      exportUrl2: taxDeclaration.taxEntrustPaymentReportThreeLevels //下载委托代征报告明细表接口
    };
  },
  computed: {
    fmtPayMonth() {
      const d = this.formInline1.payMonth;
      return d ? dateFormat(d.getTime(), 'YYYY-MM') : '';
    },
    fmtPayMonth1() {
      const d = this.formInline2.payMonth;
      return d ? dateFormat(d.getTime(), 'YYYY-MM') : '';
    }
  },
  methods: {
    close() {
      this.$parent.componentName = '';
    },
    monthChange() {
      this.enterpriseIdIndex += 1;
    },
    getQuery(query) {
      const obj = Object.assign({}, query);
      if (obj.payMonth) {
        obj.payMonth = dateFormat(obj.payMonth.getTime(), 'YYYY-MM');
      }
      return obj;
    },
    submit(url, formName, formInlineName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$exportFile(url, this.getQuery(this[formInlineName]));
        }
      });
    }
  },
  created() {
    if (this.type == 2) {
      // 二级灵工
      this.keysArr = ['payMonth'];
      //设置下载税收完税报告表接口
      this.exportUrl1 = taxDeclaration.taxPaymentReportSecondLevel;
      //设置下载委托代征报告明细表接口
      this.exportUrl2 = taxDeclaration.taxEntrustPaymentReport;
    }
  }
};
</script>

<style lang="scss">
.tax-return {
  .el-dialog {
    min-width: 550px;
  }
}
</style>
<style lang="scss" scoped>
.tax-return {
  .form-inline {
    text-align: left;
  }
  .btn-group {
    margin-top: 40px;
  }
  .l-common-title {
    text-align: left;
    margin-bottom: 20px;
    font-size: 15px;
  }
}
</style>
